"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isContentLink = void 0;
const isAnnouncementLink_1 = require("./isAnnouncementLink");
const CONTACT = /^(mailto|tel):\S+$/i;
const IN_PAGE = /^#\S+$/;
const isContentLink = (link) => (0, isAnnouncementLink_1.isAnnouncementLink)(link) || CONTACT.test(link) || IN_PAGE.test(link);
exports.isContentLink = isContentLink;
